/*
  Sculpt Nuo PDP script (templates/product.sculpt_nuo_v1.json).
  Loaded only for that template from layout/theme.liquid.
  All DOM hooks are data-snuo-* attributes.
*/
(function () {
  'use strict';

  var SLIDE_MS = 300; // must match the transition in snuo.css

  function cloneForLoop(el) {
    var clone = el.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('role');
    clone.removeAttribute('aria-label');
    if (clone.tagName === 'BUTTON') clone.tabIndex = -1;
    return clone;
  }

  // Move a track without animating (used when the loop jumps from a
  // clone back to the matching real item).
  function jump(el, transform) {
    el.style.transition = 'none';
    el.style.transform = transform;
    void el.offsetWidth; // flush so the next change animates again
    el.style.transition = '';
  }

  /* ---------------------------------------------------------------- *
   *  Gallery: infinite-loop main slider + thumb strip, like the reference.
   *
   *  The loop needs clones (the reference works the same way):
   *    main track   = [last] 0 1 ... n-1 [first]
   *    thumbs track = [last] 0 1 ... n-1 [0 1 ... n-1 ...]
   *  Position p in either track = real index + 1. Moving past an end
   *  animates onto a clone, then jumps to the real item once the
   *  transition is over. The active thumb is always the leftmost one.
   * ---------------------------------------------------------------- */
  function initGallery(gallery) {
    if (gallery.hasAttribute('data-snuo-ready')) return;

    var track = gallery.querySelector('[data-snuo-gallery-track]');
    var thumbsTrack = gallery.querySelector('[data-snuo-gallery-thumbs]');
    var viewport = gallery.querySelector('.snuo-gallery__viewport');
    var prev = gallery.querySelector('[data-snuo-gallery-prev]');
    var next = gallery.querySelector('[data-snuo-gallery-next]');
    if (!track || !thumbsTrack) return;

    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(thumbsTrack.children);
    var count = slides.length;
    if (count < 2) return;
    gallery.setAttribute('data-snuo-ready', '');

    track.insertBefore(cloneForLoop(slides[count - 1]), slides[0]);
    track.appendChild(cloneForLoop(slides[0]));

    // Enough trailing thumb copies that the strip never shows a gap,
    // even for products with only a few images.
    thumbsTrack.insertBefore(cloneForLoop(thumbs[count - 1]), thumbs[0]);
    var copies = Math.ceil(12 / count) + 1;
    for (var c = 0; c < copies; c++) {
      thumbs.forEach(function (thumb) {
        thumbsTrack.appendChild(cloneForLoop(thumb));
      });
    }

    var allThumbs = Array.prototype.slice.call(thumbsTrack.children);
    var index = 0;
    var mainPos = 1;
    var thumbPos = 1;
    var settleTimer = null;

    function thumbStep() {
      return allThumbs[1].offsetLeft - allThumbs[0].offsetLeft;
    }

    function mainTransform() {
      return 'translateX(' + (-mainPos * 100) + '%)';
    }

    function thumbTransform() {
      return 'translateX(' + (-thumbPos * thumbStep()) + 'px)';
    }

    function paintState() {
      allThumbs.forEach(function (thumb) {
        var active = Number(thumb.getAttribute('data-index')) === index;
        thumb.classList.toggle('is-active', active);
        if (!thumb.hasAttribute('aria-hidden')) {
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        }
      });
      // The reference dims "previous" on the first slide but keeps it
      // clickable (it wraps to the last slide).
      if (prev) prev.classList.toggle('is-dimmed', index === 0);
    }

    // Snap both tracks from a clone onto the real item for `index`.
    function settle() {
      clearTimeout(settleTimer);
      settleTimer = null;
      if (mainPos !== index + 1) {
        mainPos = index + 1;
        jump(track, mainTransform());
      }
      if (thumbPos !== index + 1) {
        thumbPos = index + 1;
        jump(thumbsTrack, thumbTransform());
      }
    }

    // newMainPos / newThumbPos may point at clones.
    function moveTo(newMainPos, newThumbPos) {
      if (settleTimer) settle();

      mainPos = newMainPos;
      thumbPos = newThumbPos;
      index = (((newMainPos - 1) % count) + count) % count;

      track.style.transform = mainTransform();
      thumbsTrack.style.transform = thumbTransform();
      paintState();

      settleTimer = setTimeout(settle, SLIDE_MS + 20);
    }

    // Move by `delta` images (negative = back). Single steps wrap through
    // the clones; bigger jumps (from a long thumb drag) go straight to the
    // target on the main image, since it only has one clone per side.
    function step(delta) {
      if (!delta) return;
      if (settleTimer) settle();
      var target = (((index + delta) % count) + count) % count;
      var newMain = Math.abs(delta) === 1 ? mainPos + delta : target + 1;
      // The thumb track has one leading clone only, so before going back
      // more than one, shift it forward by a full set (looks identical).
      if (thumbPos + delta < 0) {
        thumbPos += count;
        jump(thumbsTrack, thumbTransform());
      }
      moveTo(newMain, thumbPos + delta);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Clicked thumb slides to the left edge; the main image goes
    // straight to that slide.
    thumbsTrack.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-snuo-gallery-thumb]');
      if (!thumb || suppressClick) return;
      if (settleTimer) settle();
      var target = Number(thumb.getAttribute('data-index'));
      if (target === index) return;
      moveTo(target + 1, allThumbs.indexOf(thumb));
    });

    /* -------- Drag / swipe (touch and mouse) --------
       The dragged track follows the pointer; on release it moves one
       image (main) or as many thumbs as were dragged past (strip), or
       snaps back if the drag was too short. */
    var drag = null;
    var suppressClick = false;

    function startDrag(e, kind) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (settleTimer) settle();
      drag = {
        kind: kind,
        el: kind === 'main' ? track : thumbsTrack,
        x: e.clientX,
        y: e.clientY,
        dx: 0,
        t: Date.now(),
        horizontal: null,
        pointerId: e.pointerId
      };
    }

    function moveDrag(e) {
      if (!drag || e.pointerId !== drag.pointerId) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (drag.horizontal === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.horizontal = Math.abs(dx) > Math.abs(dy);
        if (!drag.horizontal) { drag = null; return; }
        drag.el.setPointerCapture(e.pointerId);
        drag.el.style.transition = 'none';
        gallery.classList.add('is-dragging');
      }
      e.preventDefault();
      drag.dx = dx;
      var base = drag.kind === 'main' ? mainTransform() : thumbTransform();
      drag.el.style.transform = base + ' translateX(' + dx + 'px)';
    }

    function endDrag(e) {
      if (!drag || e.pointerId !== drag.pointerId) return;
      var d = drag;
      drag = null;
      if (!d.horizontal) return;

      gallery.classList.remove('is-dragging');
      d.el.style.transition = '';
      // A drag must not also count as a thumb click.
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);

      var fast = Math.abs(d.dx) > 20 && Date.now() - d.t < 250;
      var delta = 0;
      if (d.kind === 'main') {
        var width = viewport.clientWidth;
        if (Math.abs(d.dx) > width * 0.15 || fast) delta = d.dx < 0 ? 1 : -1;
      } else {
        delta = -Math.round(d.dx / thumbStep());
        if (!delta && fast) delta = d.dx < 0 ? 1 : -1;
      }

      if (delta) {
        step(delta);
      } else {
        track.style.transform = mainTransform();
        thumbsTrack.style.transform = thumbTransform();
      }
    }

    track.addEventListener('pointerdown', function (e) { startDrag(e, 'main'); });
    thumbsTrack.addEventListener('pointerdown', function (e) { startDrag(e, 'thumbs'); });
    // Moves/ups bubble to window (also while the pointer is captured).
    window.addEventListener('pointermove', moveDrag, { passive: false });
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Thumb size changes between desktop and mobile.
    window.addEventListener('resize', function () {
      jump(thumbsTrack, thumbTransform());
    });

    jump(track, mainTransform());
    jump(thumbsTrack, thumbTransform());
    paintState();
  }

  /* ---------------------------------------------------------------- *
   *  Next batch box: dates relative to the visitor's today
   *  (sold out = -1 day, reserved = +2, formulating = +9 by default).
   * ---------------------------------------------------------------- */
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  function formatBatchDate(date) {
    var day = date.getDate();
    var suffix = 'th';
    if (day < 11 || day > 13) {
      suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
    }
    return MONTHS[date.getMonth()] + ' ' + day + suffix;
  }

  function initBatch(box) {
    box.querySelectorAll('[data-snuo-batch-date]').forEach(function (el) {
      var date = new Date();
      date.setDate(date.getDate() + Number(el.getAttribute('data-snuo-batch-date')));
      el.textContent = formatBatchDate(date);
    });
  }

  /* ---------------------------------------------------------------- *
   *  Simple loop slider (reviews): one slide per view, arrows + swipe.
   *  Same clone approach as the gallery:
   *    track = [last] 0 1 ... n-1 [first]
   * ---------------------------------------------------------------- */
  function initLoopSlider(slider) {
    if (slider.hasAttribute('data-snuo-ready')) return;

    var track = slider.querySelector('[data-snuo-slider-track]');
    var prev = slider.querySelector('[data-snuo-slider-prev]');
    var next = slider.querySelector('[data-snuo-slider-next]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count < 2) return;
    slider.setAttribute('data-snuo-ready', '');

    track.insertBefore(cloneForLoop(slides[count - 1]), slides[0]);
    track.appendChild(cloneForLoop(slides[0]));

    var viewport = track.parentElement;
    var pos = 1;
    var settleTimer = null;

    function transform(extraPx) {
      return 'translateX(calc(' + (-pos * 100) + '% + ' + (extraPx || 0) + 'px))';
    }

    // After animating onto a clone, jump to the real slide.
    function settle() {
      clearTimeout(settleTimer);
      settleTimer = null;
      var real = pos < 1 ? count : pos > count ? 1 : pos;
      if (real !== pos) {
        pos = real;
        jump(track, transform());
      }
    }

    function step(delta) {
      if (settleTimer) settle();
      pos += delta;
      track.style.transform = transform();
      settleTimer = setTimeout(settle, SLIDE_MS + 20);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Swipe: the track follows the finger, then moves or snaps back.
    var drag = null;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (settleTimer) settle();
      drag = { x: e.clientX, y: e.clientY, dx: 0, t: Date.now(), horizontal: null, id: e.pointerId };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (drag.horizontal === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.horizontal = Math.abs(dx) > Math.abs(dy);
        if (!drag.horizontal) { drag = null; return; }
        track.setPointerCapture(e.pointerId);
        track.style.transition = 'none';
      }
      e.preventDefault();
      drag.dx = dx;
      track.style.transform = transform(dx);
    }, { passive: false });
    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.horizontal) return;
      track.style.transition = '';
      var fast = Math.abs(d.dx) > 20 && Date.now() - d.t < 250;
      if (Math.abs(d.dx) > viewport.clientWidth * 0.15 || fast) {
        step(d.dx < 0 ? 1 : -1);
      } else {
        track.style.transform = transform();
      }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    jump(track, transform());
  }

  /* ---------------------------------------------------------------- *
   *  Flush calculator
   *    BMI    = round(703 × lbs / in²)
   *    tier   = by rounded BMI: <=18, 19-24, 25-29, 30-34, 35+
   *    result = round(lbs × tier rate), kept within [min, max]
   *  Slider input is throttled to 50ms, the result counts to its new
   *  value over 300ms, and the tier message fades in (CSS, 150ms).
   * ---------------------------------------------------------------- */
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bmiTier(bmi) {
    if (bmi <= 18) return 'underweight';
    if (bmi <= 24) return 'healthy';
    if (bmi <= 29) return 'overweight';
    if (bmi <= 34) return 'obese1';
    return 'obese2';
  }

  // Leading + trailing throttle.
  function throttle(fn, wait) {
    var last = 0;
    var timer = null;
    return function () {
      var now = Date.now();
      var remaining = wait - (now - last);
      clearTimeout(timer);
      if (remaining <= 0) {
        last = now;
        fn();
      } else {
        timer = setTimeout(function () {
          last = Date.now();
          fn();
        }, remaining);
      }
    };
  }

  function initCalculator(calc) {
    if (calc.hasAttribute('data-snuo-ready')) return;
    calc.setAttribute('data-snuo-ready', '');

    var weightInput = calc.querySelector('[data-snuo-calc-weight]');
    var heightInput = calc.querySelector('[data-snuo-calc-height]');
    var weightOut = calc.querySelector('[data-snuo-calc-weight-out]');
    var heightOut = calc.querySelector('[data-snuo-calc-height-out]');
    var bmiOut = calc.querySelector('[data-snuo-calc-bmi]');
    var lossOut = calc.querySelector('[data-snuo-calc-loss]');
    var fluidOut = calc.querySelector('[data-snuo-calc-fluid]');
    var wasteOut = calc.querySelector('[data-snuo-calc-waste]');
    var levels = Array.prototype.slice.call(calc.querySelectorAll('[data-snuo-calc-level]'));
    if (!weightInput || !heightInput) return;

    var unit = calc.getAttribute('data-unit') || '';
    var lossMin = Number(calc.getAttribute('data-loss-min'));
    var lossMax = Number(calc.getAttribute('data-loss-max'));
    var split = Number(calc.getAttribute('data-split')) / 100;

    var shownLoss = Number(lossOut.textContent) || 0;
    var currentTier = null;
    levels.forEach(function (el) {
      if (!el.hidden) currentTier = el.getAttribute('data-snuo-calc-level');
    });
    var frame = null;

    function animateLoss(target) {
      cancelAnimationFrame(frame);
      var from = shownLoss;
      if (REDUCED_MOTION || from === target) {
        shownLoss = target;
        lossOut.textContent = target;
        return;
      }
      var start = null;
      function tick(time) {
        if (start === null) start = time;
        var t = Math.min(1, (time - start) / 300);
        var eased = 1 - Math.pow(1 - t, 3); // ease-out
        shownLoss = Math.round(from + (target - from) * eased);
        lossOut.textContent = shownLoss;
        if (t < 1) frame = requestAnimationFrame(tick);
      }
      frame = requestAnimationFrame(tick);
    }

    function showTier(tier) {
      if (tier === currentTier) return;
      currentTier = tier;
      levels.forEach(function (el) {
        var on = el.getAttribute('data-snuo-calc-level') === tier;
        el.hidden = !on;
        el.classList.remove('is-entering');
        if (on) {
          void el.offsetWidth; // restart the fade
          el.classList.add('is-entering');
        }
      });
    }

    function update() {
      var weight = parseInt(weightInput.value, 10);
      var height = parseInt(heightInput.value, 10);
      var bmi = Math.round((703 * weight) / (height * height));
      var tier = bmiTier(bmi);
      var rate = Number(calc.getAttribute('data-pct-' + tier)) / 100;
      var loss = Math.min(lossMax, Math.max(lossMin, Math.round(weight * rate)));

      weightOut.textContent = weight + ' ' + unit;
      heightOut.textContent = Math.floor(height / 12) + 'ft ' + (height % 12) + 'in';
      bmiOut.textContent = bmi;
      if (fluidOut) fluidOut.textContent = Math.round(loss * split);
      if (wasteOut) wasteOut.textContent = Math.round(loss * (1 - split));
      animateLoss(loss);
      showTier(tier);
    }

    var throttledUpdate = throttle(update, 50);
    weightInput.addEventListener('input', throttledUpdate);
    heightInput.addEventListener('input', throttledUpdate);

    // "View more": reveal the breakdown once and hide the link.
    var moreBtn = calc.querySelector('[data-snuo-calc-more-btn]');
    var more = calc.querySelector('[data-snuo-calc-more]');
    if (moreBtn && more) {
      moreBtn.addEventListener('click', function () {
        more.hidden = false;
        moreBtn.setAttribute('aria-expanded', 'true');
        moreBtn.hidden = true;
      });
    }

    update();
  }

  /* ---------------------------------------------------------------- *
   *  FAQ: native <details> with an animated height (300ms).
   *  Only one answer is open at a time; a click during an animation
   *  continues from the current height.
   * ---------------------------------------------------------------- */
  var FAQ_MS = 300;

  function initFaq(list) {
    if (list.hasAttribute('data-snuo-ready')) return;
    list.setAttribute('data-snuo-ready', '');
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-snuo-faq-item]'));

    // Where the item is heading (details.open stays true while closing).
    items.forEach(function (item) {
      item._snuoOpen = item.open;
    });

    function setItem(item, open) {
      if (item._snuoOpen === open) return;
      item._snuoOpen = open;
      item.classList.toggle('is-closing', !open);
      var answer = item.querySelector('[data-snuo-faq-answer]');

      if (REDUCED_MOTION || !answer.animate) {
        item.open = open;
        item.classList.remove('is-closing');
        return;
      }

      // Current visual height (mid-animation or settled) before stopping.
      var from = item.open ? answer.getBoundingClientRect().height : 0;
      if (item._snuoAnim) item._snuoAnim.cancel();

      item.open = true; // must be open to measure / show while closing
      var to = open ? answer.scrollHeight : 0;

      var anim = answer.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: FAQ_MS, easing: 'ease' }
      );
      item._snuoAnim = anim;
      anim.onfinish = function () {
        item._snuoAnim = null;
        if (!open) item.open = false;
        item.classList.remove('is-closing');
      };
    }

    items.forEach(function (item) {
      item.querySelector('summary').addEventListener('click', function (event) {
        event.preventDefault();
        var open = !item._snuoOpen;
        if (open) {
          items.forEach(function (other) {
            if (other !== item) setItem(other, false);
          });
        }
        setItem(item, open);
      });
    });
  }

  /* ---------------------------------------------------------------- *
   *  "View Nutrition Label" opens the site's nutrition popup section.
   *  Closing is handled site-wide by assets/sitewide.js.
   * ---------------------------------------------------------------- */
  function initNutrition(link) {
    if (link.hasAttribute('data-snuo-ready')) return;
    link.setAttribute('data-snuo-ready', '');
    link.addEventListener('click', function (event) {
      var popup = document.querySelector('.nutrition_popup-outer');
      if (!popup) return; // no popup section on the page: follow the link
      event.preventDefault();
      popup.style.display = 'flex';
    });
  }

  /* ---------------------------------------------------------------- *
   *  Countdown bar: time left until the next midnight in the store's
   *  chosen US timezone (read from the clock in that zone, so it is the
   *  same countdown for every visitor wherever they are).
   * ---------------------------------------------------------------- */
  function secondsUntilMidnight(timeZone) {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).formatToParts(new Date());
    } catch (e) {
      return null; // unknown timezone: leave the bar as rendered
    }
    var get = function (type) {
      var part = parts.filter(function (p) { return p.type === type; })[0];
      return part ? parseInt(part.value, 10) % 24 : 0;
    };
    var elapsed = get('hour') * 3600 + get('minute') * 60 + get('second');
    return 86400 - elapsed;
  }

  function initCountdown(bar) {
    if (bar.hasAttribute('data-snuo-ready')) return;
    bar.setAttribute('data-snuo-ready', '');

    var timeZone = bar.getAttribute('data-timezone') || 'America/New_York';
    var hours = bar.querySelector('[data-snuo-countdown-hours]');
    var minutes = bar.querySelector('[data-snuo-countdown-minutes]');
    var seconds = bar.querySelector('[data-snuo-countdown-seconds]');
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };

    function tick() {
      var left = secondsUntilMidnight(timeZone);
      if (left === null) return;
      hours.textContent = pad(Math.floor(left / 3600));
      minutes.textContent = pad(Math.floor(left / 60) % 60);
      seconds.textContent = pad(left % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------- *
   *  [data-snuo-scroll-to]: smooth scroll to a section on this page,
   *  leaving room for the sticky header so its top isn't hidden.
   * ---------------------------------------------------------------- */
  // The theme header hides while scrolling down and slides back in on the
  // way up, so reserve its full height whenever it is sticky/fixed.
  function stickyHeaderOffset() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!header) return 0;
    var position = getComputedStyle(header).position;
    return position === 'sticky' || position === 'fixed' ? header.offsetHeight : 0;
  }

  function scrollToSection(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
  }

  function initScrollTo(link) {
    if (link.hasAttribute('data-snuo-ready')) return;
    link.setAttribute('data-snuo-ready', '');
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('data-snuo-scroll-to'));
      if (!target) return;
      event.preventDefault();
      scrollToSection(target);
    });
  }

  /* ---------------------------------------------------------------- *
   *  Shared theme sections (UGC etc.) use .product_primary-btn.scrolling,
   *  which sitewide.js scrolls to ".main_product-container" — a container
   *  this template does not have. Take those clicks in the capture phase
   *  and scroll to the product section instead.
   * ---------------------------------------------------------------- */
  function initLegacyScrollButtons() {
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest) return;
        var button = event.target.closest('.product_primary-btn.scrolling');
        if (!button || button.getAttribute('href') !== 'javascript:void(0)') return;
        var target = document.querySelector('#snuo-pdp');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation(); // keep sitewide.js off a container that is not here
        scrollToSection(target);
      },
      true
    );
  }

  function init(root) {
    root.querySelectorAll('[data-snuo-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-snuo-batch]').forEach(initBatch);
    root.querySelectorAll('[data-snuo-slider]').forEach(initLoopSlider);
    root.querySelectorAll('[data-snuo-calc]').forEach(initCalculator);
    root.querySelectorAll('[data-snuo-faq]').forEach(initFaq);
    root.querySelectorAll('[data-snuo-nutrition-open]').forEach(initNutrition);
    root.querySelectorAll('[data-snuo-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-snuo-scroll-to]').forEach(initScrollTo);
  }

  initLegacyScrollButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
